module.exports = __webpack_public_path__ + "static/media/10-14.d17843f9.mp3";